
import { h, Fragment } from 'preact'; /** @jsx h */
import { lazy } from 'preact-iso';
import { useEffect, useState } from 'preact/hooks';


import { ROUTES, timestampStringInEnglish } from '@pyqml/shared';

import { useAuth } from "../app/AuthProvider";
import { useEnvironment } from "../app/Environment";
import { Layout } from '../components/Layout';
import { BlogCover } from '../components/BlogCover';
import { Subscribe } from '../components/Subscribe';


export const Questionnaire = (props) => {
    
    
    const { authPromise, subscriptionLevel } = useAuth();
	
    const [ responseData, setResponseData ] = useState<any>(undefined);
    
    const likertOptions = [
        "Strongly disagree",
        "Disagree",
        "Neither agree nor disagree",
        "Agree",
        "Strongly agree"
    ];

    const questions = [
        {
            category: "demographics",
            id: "dmg1",
            question: "What is your primary educational background?",
            questionType: "options",
            options: [
                "Mathematics",
                "Physics",
                "Computer Science",
                "Data Science",
                "Other"
            ]
        }, {
            category: "demographics",
            id: "dmg2",
            question: "In your view, quantum computing is primarily?",
            questionType: "options",
            options: [
                "A quantum mechanical perspective",
                "A mathematical construct",
                "A statistical modeling technique",
                "A programming paradigm (like object-oriented, functional, etc.)"
            ]
        }, {
            category: "adoption",
            id: "ad1",
            question: "How far have you progressed with learning in the field of quantum computing?",
            questionType: "options",
            options: [
                "I have not started to learn or study systematically",
                "I have already read books and/or other learning materials",
                "I have tried out simulations and examples",
                "I use quantum algorithms actively"
            ]
        },
        {
            category: "usefulness",
            id: "pu1",
            question: "Quantum algorithms will outperform classical algorithms in the near or medium term, at least for certain tasks",
            questionType: "likert",
        },
        {
            category: "usefulness",
            id: "pu2",
            question: "Knowledge of quantum algorithms could be a career advantage for me",
            questionType: "likert",
        },
        {
            category: "usefulness",
            id: "pu3",
            question: "I believe that quantum computing could be useful for solving complex problems",
            questionType: "likert",
        }, {
            category: "ease",
            id: "eu1",
            question: "Learning quantum computing would be easy for me",
            questionType: "likert",
        }, {
            category: "ease",
            id: "eu2",
            question: "I find the concepts of quantum computing straightforward to understand",
            questionType: "likert",
        }, {
            category: "ease",
            id: "eu3",
            question: "Learning how to use quantum algorithms seems manageable to me",
            questionType: "likert",
        }, {
            category: "intention",
            id: "in1",
            question: "I intend to get involved with quantum algorithms in the near future",
            questionType: "likert",
        }, {
            category: "intention",
            id: "in2",
            question: "I intend to deepen my knowledge of quantum computing soon",
            questionType: "likert",
        }, {
            category: "intention",
            id: "in3",
            question: "I would buy books/courses if they help me to use or create quantum algorithms",
            questionType: "likert",
        }, {
            category: "math",
            id: "ma1",
            question: "I work with equations regularly",
            questionType: "likert",
        }, {
            category: "math",
            id: "ma2",
            question: "Reading equations comes naturally to me",
            questionType: "likert",
        }, {
            category: "math",
            id: "ma3",
            question: "I prefer mathematical symbols over plain text descriptions",
            questionType: "likert",
        }, {
            category: "physics",
            id: "ph1",
            question: "I work with physical jargon regularly",
            questionType: "likert",
        }, {
            category: "physics",
            id: "ph1",
            question: "I can easily understand and reason about physics concepts",
            questionType: "likert",
        }, {
            category: "physics",
            id: "ph1",
            question: "I am comfortable discussing physics-related topics",
            questionType: "likert",
        }

    ];

    return <Layout.Stacked>
        <Fragment as="Section">
                <BlogCover
                    title="Early Adoption of Quantum Computing"
                    subtitle="Take part in our current research project on quantum computing" />
                
        </Fragment>
       
        {
            !responseData &&
            <Layout.Section weight="full">
                <h2 style={{marginTop:"1.5em"}}>What's this about?</h2>
                <p>
                    This questionnaire is part of our current research project on quantum computing.
                    We want to understand whether quantum computing is being learned in the technical community.
                </p>
                <p>
                    We specifically want to understand the factors that inhibit or promote the early adoption of quantum computing.
                </p>
                <p>
                    All responses are anonymous. We intend to publish the results of this survey on arXiv.
                </p>
                
                <h2 style={{marginBottom:"1.5em"}}>Who's behind this?</h2>
                <p>

                    My name is <b>Frank Zickert</b> and I am a Quantum Machine Learning Researcher.
                    I am currently engaged in a research project focused on quantum computing. You can find me
                    on <a href="https://www.linkedin.com/in/frank-c-zickert-phd-544654333/" target="_blank">LinkedIn</a>.
                </p>

                <hr />
                
            </Layout.Section>
        }

        <Layout.Section weight="full">
            
            {
                responseData?.responseId
                ? <Fragment>
                    <h2 style={{marginTop:"1.5em"}}>Thank you</h2>
                    <p>{ responseData.message }</p>
                    { !subscriptionLevel && <Fragment>
                            <p><b>Has it whetted your appetite for Quantum Computing?</b></p>
                            <Subscribe referenceId={ typeof responseData?.responseId === 'string' ? responseData?.responseId : undefined } referenceType="questionnaire"/>
                        </Fragment>
                    }
                </Fragment>
                : <Fragment>
                    <h2>Questionnaire</h2>
                    <ul class="question">
                        {questions.map((question, index) => (
                            <li key={index}>
                                <b>{question.question}</b>
                                <div>
                                    {question.questionType === "likert" ? (
                                        likertOptions.map((option, optIndex) => (
                                            <label key={optIndex}>
                                                <input type="radio" name={`question${index}`} value={optIndex + 1} /> {option}
                                            </label>
                                        ))
                                    ) : (
                                        question?.options?.map((option, optIndex) => (
                                            <label key={optIndex}>
                                                <input type="radio" name={`question${index}`} value={optIndex + 1} /> {option}
                                            </label>
                                        ))
                                    )}
                                </div>
                            </li>
                        ))}
                    </ul>

                    <div>
                        <button
                            type="submit"
                            className="btn btn-success btn-block"
                            
                            onClick={()=> {
                                setResponseData({ message: "Please wait"});
                                
                                const answers = questions.map((_, index) => {
                                    const radios = document.getElementsByName(`question${index}`);
                                    let selectedValue;
                                    for (let i = 0; i < radios.length; i++) {
                                        const radio = radios[i] as HTMLInputElement;
                                        if (radio.checked) {
                                            selectedValue = radio.value;
                                            break;
                                        }
                                    }
                                    return {
                                        ...questions[index],
                                        questionIndex: index,
                                        answer: selectedValue
                                    };
                                });

                                authPromise?.({
                                    method: "post",
                                    endpoint: ROUTES.CLOUDAPI_PUBLIC_SUBMIT_QUESTIONNAIRE,
                                    queryData: {
                                        answers: answers,
                                    }
                                }).then(response => {
                                    console.log("response", response);
                                    setResponseData({
                                        responseId: response.data.responseId,
                                        message: "Thank you for participating in our research project. Your responses have been recorded."
                                    });
                        
                                }).catch(err => {
                                    console.log("error", err);
                                    setResponseData({
                                        responseId: true,
                                        message: "Thank you for participating in our research project. Your responses have been recorded."
                                    });
                                });
                                
                                
                            }}
                        >Submit</button> 
                    </div>
                </Fragment>
            }
        </Layout.Section>
        

    </Layout.Stacked>
            
}
  
